import { LOGIN_STORAGE_USER, type StoredUser } from 'auth/domain/User'
import { type StorageInterface } from 'core/infra/storage/StorageInterface'

export type { StoredUser }

/**
 * Read the logged-in user from storage.
 *
 * Every login stores the user as an object. OpenDock logins used to store it as
 * a JSON string (double-encoded, so it comes back as a string). Sessions from
 * before that fix still hold the string, so this handles both shapes.
 */
export function getStoredUser(storage: StorageInterface): StoredUser | null {
  let user = storage.get<StoredUser | string>(LOGIN_STORAGE_USER)

  if (typeof user === 'string') {
    try {
      user = JSON.parse(user) as StoredUser
    } catch {
      return null
    }
  }

  if (!user || typeof user !== 'object') {
    return null
  }

  return user
}
